// An account is a resource too, so the Cloud tab is one list instead of an accounts table beside a resources one.
export const CLOUD_RESOURCE_TYPES = {
  ACCOUNT: 'account',
  KUBERNETES: 'kubernetes',
  COMPUTE: 'compute',
  BUCKET: 'bucket',
  DATABASE: 'database',
  FUNCTION: 'function',
  LOAD_BALANCER: 'load_balancer',
  REGISTRY: 'registry',
  KEY: 'key',
} as const

export type ICloudResourceType = (typeof CLOUD_RESOURCE_TYPES)[keyof typeof CLOUD_RESOURCE_TYPES]

export const CLOUD_RESOURCE_TYPE_VALUES = Object.values(CLOUD_RESOURCE_TYPES)

// Provider-reported settings shown in the drawer; the list order is the drawer order.
export const CLOUD_RESOURCE_DETAILS = {
  ENGINE: 'engine',
  KUBERNETES_VERSION: 'kubernetes_version',
  RUNTIME: 'runtime',
  INSTANCE_TYPE: 'instance_type',
  IMAGE: 'image',
  NODES: 'nodes',
  MEMORY_MB: 'memory_mb',
  SIZE: 'size',
  IMAGES: 'images',
  KEY_SPEC: 'key_spec',
  ENCRYPTION: 'encryption',
  ROTATION_DAYS: 'rotation_days',
  VERSIONING: 'versioning',
  BACKUP_RETENTION_DAYS: 'backup_retention_days',
  VULNERABILITY_SCANNING: 'vulnerability_scanning',
  PUBLIC_ENDPOINT: 'public_endpoint',
  PUBLIC_ACCESS: 'public_access',
  PUBLIC_IP: 'public_ip',
  TLS_POLICY: 'tls_policy',
  WAF: 'waf',
} as const

export type ICloudResourceDetail = (typeof CLOUD_RESOURCE_DETAILS)[keyof typeof CLOUD_RESOURCE_DETAILS]

export const CLOUD_RESOURCE_DETAIL_VALUES = Object.values(CLOUD_RESOURCE_DETAILS)
